import axios from 'axios';
import * as Cookies from '../utils/cookies';

export async function EditGroupApi(
  leagueId,
  groupId,
  groupName,
  groupSlogan,
  groupImg
) {
  const token = Cookies.getToken();


  const formData = new FormData();
  formData.append('name', groupName);
  formData.append('is_active', true);
  if (groupImg !== null) {
    formData.append('image', groupImg);
  }
  formData.append('slogan', groupSlogan);

  const res = await axios({
    method: 'PATCH',
    url:
      process.env.REACT_APP_API_URL +
      `/api/league/leagues/${leagueId}/teams/${groupId}/`,
    headers: { Authorization: `Bearer ${token}` },
    data: formData,
  });

  if (res.status === 200) {
    return res;
  } else {
    return { error: res.status };
  }
}

